export default function SplashLoader({ label = "Memuat data..." }) {
  return (
    <div
      data-testid="splash-loader"
      className="min-h-screen flex flex-col items-center justify-center bg-[#0A0A0A] text-white gap-6"
    >
      <div className="relative">
        <div className="absolute inset-0 rounded-full bg-[#0055FF]/20 blur-2xl animate-pulse" />
        <img
          src="/logo-transparan.png"
          alt="AROMA NET"
          className="relative h-24 w-auto object-contain animate-pulse"
          style={{ filter: "invert(1) hue-rotate(180deg)" }}
        />
      </div>
      <div className="flex items-center gap-1.5">
        <span className="h-1.5 w-1.5 rounded-full bg-[#0055FF] animate-bounce" style={{ animationDelay: "0ms" }} />
        <span className="h-1.5 w-1.5 rounded-full bg-[#0055FF] animate-bounce" style={{ animationDelay: "150ms" }} />
        <span className="h-1.5 w-1.5 rounded-full bg-[#0055FF] animate-bounce" style={{ animationDelay: "300ms" }} />
      </div>
      <div className="text-[10px] font-bold uppercase tracking-[0.3em] text-white/50">
        {label}
      </div>
    </div>
  );
}
